/**
 * @flow
 * @relayHash 521470c046c8ded0ddcc35744636266d
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type MultiContactDealerModalRendererQueryResponse = {|
  +viewer: ?{| |};
|};
*/


/*
query MultiContactDealerModalRendererQuery(
  $userId: String = ""
  $userIds: [String]
  $itemId: String = ""
  $sellerId: String = ""
  $hasSellerId: Boolean = false
  $shouldFetchItem: Boolean!
  $hasUserId: Boolean!
  $zipCode: String = ""
  $country: String = ""
  $canCheckZipCode: Boolean = false
) {
  viewer {
    ...MultiRequestContactDealer_viewer
    ...BulkHoldRequest_viewer
    id
  }
}

fragment MultiRequestContactDealer_viewer on Viewer {
  ...MultiRequestContactDealerForm_viewer
  user(userId: $userId) @include(if: $hasUserId) {
    ...MultiRequestContactDealerForm_user
    ...MultiRequestContactDealerConfirmation_user
    id
  }
  item(itemId: $itemId) @include(if: $shouldFetchItem) {
    ...MultiRequestContactDealerForm_item
    ...MultiRequestContactDealerConfirmation_item
    id
  }
}

fragment BulkHoldRequest_viewer on Viewer {
  ...HoldRequestContent_viewer
  user(userId: $userId) @include(if: $hasUserId) {
    ...HoldRequestContent_user
    serviceId
    id
  }
}

fragment HoldRequestContent_viewer on Viewer {
  ...SharedSelectProject_viewer
}

fragment HoldRequestContent_user on User {
  ...SharedSelectProject_user
  isVerifiedTrade
}

fragment SharedSelectProject_user on User {
  serviceId
  tradeFirm {
    serviceId
    id
  }
}

fragment SharedSelectProject_viewer on Viewer {
  projects(userIds: $userIds, first: 200) @include(if: $hasUserId) {
    edges {
      node {
        serviceId
        name
        portfolio {
          serviceId
          id
        }
        id
      }
    }
  }
}

fragment MultiRequestContactDealerForm_viewer on Viewer {
  ...RequestShippingQuote_viewer
  ...SharedSelectProject_viewer
  seller(sellerId: $sellerId) @include(if: $hasSellerId) {
    sellerProfile {
      trackedPhoneNumber
    }
    id
  }
  buyerItemConversation(buyerId: $userId, itemId: $itemId) @include(if: $hasUserId) {
    transaction {
      isCanceled
      hasCompletedCheckout
      requestedQuote {
        id
      }
      id
    }
    id
  }
}

fragment MultiRequestContactDealerForm_user on User {
  ...RequestShippingQuote_user
  ...SharedSelectProject_user
  serviceId
  canUseNetPrice: hasPermission(name: "B_NET_PRICE")
}

fragment MultiRequestContactDealerConfirmation_user on User {
  serviceId
  phones {
    status
    id
  }
  newsletters {
    smsOptin
    id
  }
  ...SmsNotifications_user
}

fragment MultiRequestContactDealerForm_item on Item {
  serviceId
  vertical
  seller {
    serviceId
    id
  }
  hasRequestedHoldForBuyer(buyerId: $userId) @include(if: $hasUserId)
  projects(userId: $userId) @include(if: $hasUserId) {
    serviceId
    createdDate
    name
    id
  }
  isPriceUponRequest
  isOnHold
  isSold
  attributes {
    customizable {
      value
    }
  }
}

fragment MultiRequestContactDealerConfirmation_item on Item {
  serviceId
  vertical
  seller {
    serviceId
    favoritesByUser(userIds: $userId) @include(if: $hasUserId) {
      serviceId
      id
    }
    sellerProfile {
      company
    }
    id
  }
}

fragment SmsNotifications_user on User {
  serviceId
  primarySmsPhoneNumber {
    serviceId
    phoneNumber
    status
    id
  }
  newsletters {
    smsOptin
    id
  }
}

fragment RequestShippingQuote_user on User {
  ...AddressSelector_user
}

fragment AddressSelector_user on User {
  serviceId
  firstValidShippingAddress {
    serviceId
    id
  }
  addressBook {
    addressList {
      serviceId
      line2
      displayName
      formattedAddress
      displayCountry
      firstName
      lastName
      line1
      sourceId
      country
      city
      state
      zipCode
      phoneNumber
      validation {
        buyerShipping {
          valid
        }
      }
      id
    }
  }
}

fragment RequestShippingQuote_viewer on Viewer {
  ...AddressSelector_viewer
}

fragment AddressSelector_viewer on Viewer {
  ...AddressForm_viewer
}

fragment AddressForm_viewer on Viewer {
  geography {
    countries {
      name
      abbreviation
    }
    usStates {
      name
      abbreviation
    }
  }
  zipCodeLookUp: zipCode(zipCode: $zipCode, country: $country) @include(if: $canCheckZipCode) {
    city
    state
    id
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String",
        "defaultValue": ""
      },
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "itemId",
        "type": "String",
        "defaultValue": ""
      },
      {
        "kind": "LocalArgument",
        "name": "sellerId",
        "type": "String",
        "defaultValue": ""
      },
      {
        "kind": "LocalArgument",
        "name": "hasSellerId",
        "type": "Boolean",
        "defaultValue": false
      },
      {
        "kind": "LocalArgument",
        "name": "shouldFetchItem",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasUserId",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "zipCode",
        "type": "String",
        "defaultValue": ""
      },
      {
        "kind": "LocalArgument",
        "name": "country",
        "type": "String",
        "defaultValue": ""
      },
      {
        "kind": "LocalArgument",
        "name": "canCheckZipCode",
        "type": "Boolean",
        "defaultValue": false
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MultiContactDealerModalRendererQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "MultiRequestContactDealer_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "BulkHoldRequest_viewer",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "MultiContactDealerModalRendererQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String",
        "defaultValue": ""
      },
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "itemId",
        "type": "String",
        "defaultValue": ""
      },
      {
        "kind": "LocalArgument",
        "name": "sellerId",
        "type": "String",
        "defaultValue": ""
      },
      {
        "kind": "LocalArgument",
        "name": "hasSellerId",
        "type": "Boolean",
        "defaultValue": false
      },
      {
        "kind": "LocalArgument",
        "name": "shouldFetchItem",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasUserId",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "zipCode",
        "type": "String",
        "defaultValue": ""
      },
      {
        "kind": "LocalArgument",
        "name": "country",
        "type": "String",
        "defaultValue": ""
      },
      {
        "kind": "LocalArgument",
        "name": "canCheckZipCode",
        "type": "Boolean",
        "defaultValue": false
      }
    ],
    "kind": "Root",
    "name": "MultiContactDealerModalRendererQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Geography",
            "name": "geography",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "GeographyObject",
                "name": "countries",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "abbreviation",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "GeographyObject",
                "name": "usStates",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "abbreviation",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "shouldFetchItem",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "itemId",
                    "variableName": "itemId",
                    "type": "String!"
                  }
                ],
                "concreteType": "Item",
                "name": "item",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "vertical",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "name": "seller",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerProfile",
                        "name": "sellerProfile",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "company",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "hasUserId",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "userIds",
                                "variableName": "userId",
                                "type": "String!"
                              }
                            ],
                            "concreteType": "Favorite",
                            "name": "favoritesByUser",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "serviceId",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "isPriceUponRequest",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "isOnHold",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "isSold",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemAttributes",
                    "name": "attributes",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "name": "customizable",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "hasUserId",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "userId",
                            "type": "String!"
                          }
                        ],
                        "name": "hasRequestedHoldForBuyer",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId",
                            "type": "String!"
                          }
                        ],
                        "concreteType": "Project",
                        "name": "projects",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "serviceId",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "createdDate",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasSellerId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "sellerId",
                    "variableName": "sellerId",
                    "type": "String!"
                  }
                ],
                "concreteType": "Seller",
                "name": "seller",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "SellerProfile",
                    "name": "sellerProfile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "trackedPhoneNumber",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 200,
                    "type": "Int"
                  },
                  {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "userIds",
                    "type": "[String]"
                  }
                ],
                "concreteType": "ProjectConnection",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectEdge",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Project",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "serviceId",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "PortfolioV2",
                            "name": "portfolio",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "serviceId",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userId",
                    "type": "String!"
                  },
                  {
                    "kind": "Variable",
                    "name": "itemId",
                    "variableName": "itemId",
                    "type": "String!"
                  }
                ],
                "concreteType": "Conversation",
                "name": "buyerItemConversation",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Transaction",
                    "name": "transaction",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "isCanceled",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "hasCompletedCheckout",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "ShipmentQuote",
                        "name": "requestedQuote",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "concreteType": "User",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "name": "firstValidShippingAddress",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "AddressBook",
                    "name": "addressBook",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "name": "addressList",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "sourceId",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "serviceId",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "displayName",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "formattedAddress",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "displayCountry",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "lastName",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "line1",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "line2",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "country",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "city",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "state",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "zipCode",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "phoneNumber",
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "AddressValidation",
                            "name": "validation",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": null,
                                "concreteType": "ValidationResult",
                                "name": "buyerShipping",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "valid",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "name": "tradeFirm",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "canUseNetPrice",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_NET_PRICE",
                        "type": "String!"
                      }
                    ],
                    "name": "hasPermission",
                    "storageKey": "hasPermission{\"name\":\"B_NET_PRICE\"}"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Phone",
                    "name": "phones",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "NewsLetter",
                    "name": "newsletters",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "smsOptin",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Phone",
                    "name": "primarySmsPhoneNumber",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "phoneNumber",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "isVerifiedTrade",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "canCheckZipCode",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "zipCodeLookUp",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "country",
                    "variableName": "country",
                    "type": "String!"
                  },
                  {
                    "kind": "Variable",
                    "name": "zipCode",
                    "variableName": "zipCode",
                    "type": "String!"
                  }
                ],
                "concreteType": "Address",
                "name": "zipCode",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "city",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "state",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query MultiContactDealerModalRendererQuery(\n  $userId: String = \"\"\n  $userIds: [String]\n  $itemId: String = \"\"\n  $sellerId: String = \"\"\n  $hasSellerId: Boolean = false\n  $shouldFetchItem: Boolean!\n  $hasUserId: Boolean!\n  $zipCode: String = \"\"\n  $country: String = \"\"\n  $canCheckZipCode: Boolean = false\n) {\n  viewer {\n    ...MultiRequestContactDealer_viewer\n    ...BulkHoldRequest_viewer\n    id\n  }\n}\n\nfragment MultiRequestContactDealer_viewer on Viewer {\n  ...MultiRequestContactDealerForm_viewer\n  user(userId: $userId) @include(if: $hasUserId) {\n    ...MultiRequestContactDealerForm_user\n    ...MultiRequestContactDealerConfirmation_user\n    id\n  }\n  item(itemId: $itemId) @include(if: $shouldFetchItem) {\n    ...MultiRequestContactDealerForm_item\n    ...MultiRequestContactDealerConfirmation_item\n    id\n  }\n}\n\nfragment BulkHoldRequest_viewer on Viewer {\n  ...HoldRequestContent_viewer\n  user(userId: $userId) @include(if: $hasUserId) {\n    ...HoldRequestContent_user\n    serviceId\n    id\n  }\n}\n\nfragment HoldRequestContent_viewer on Viewer {\n  ...SharedSelectProject_viewer\n}\n\nfragment HoldRequestContent_user on User {\n  ...SharedSelectProject_user\n  isVerifiedTrade\n}\n\nfragment SharedSelectProject_user on User {\n  serviceId\n  tradeFirm {\n    serviceId\n    id\n  }\n}\n\nfragment SharedSelectProject_viewer on Viewer {\n  projects(userIds: $userIds, first: 200) @include(if: $hasUserId) {\n    edges {\n      node {\n        serviceId\n        name\n        portfolio {\n          serviceId\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment MultiRequestContactDealerForm_viewer on Viewer {\n  ...RequestShippingQuote_viewer\n  ...SharedSelectProject_viewer\n  seller(sellerId: $sellerId) @include(if: $hasSellerId) {\n    sellerProfile {\n      trackedPhoneNumber\n    }\n    id\n  }\n  buyerItemConversation(buyerId: $userId, itemId: $itemId) @include(if: $hasUserId) {\n    transaction {\n      isCanceled\n      hasCompletedCheckout\n      requestedQuote {\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment MultiRequestContactDealerForm_user on User {\n  ...RequestShippingQuote_user\n  ...SharedSelectProject_user\n  serviceId\n  canUseNetPrice: hasPermission(name: \"B_NET_PRICE\")\n}\n\nfragment MultiRequestContactDealerConfirmation_user on User {\n  serviceId\n  phones {\n    status\n    id\n  }\n  newsletters {\n    smsOptin\n    id\n  }\n  ...SmsNotifications_user\n}\n\nfragment MultiRequestContactDealerForm_item on Item {\n  serviceId\n  vertical\n  seller {\n    serviceId\n    id\n  }\n  hasRequestedHoldForBuyer(buyerId: $userId) @include(if: $hasUserId)\n  projects(userId: $userId) @include(if: $hasUserId) {\n    serviceId\n    createdDate\n    name\n    id\n  }\n  isPriceUponRequest\n  isOnHold\n  isSold\n  attributes {\n    customizable {\n      value\n    }\n  }\n}\n\nfragment MultiRequestContactDealerConfirmation_item on Item {\n  serviceId\n  vertical\n  seller {\n    serviceId\n    favoritesByUser(userIds: $userId) @include(if: $hasUserId) {\n      serviceId\n      id\n    }\n    sellerProfile {\n      company\n    }\n    id\n  }\n}\n\nfragment SmsNotifications_user on User {\n  serviceId\n  primarySmsPhoneNumber {\n    serviceId\n    phoneNumber\n    status\n    id\n  }\n  newsletters {\n    smsOptin\n    id\n  }\n}\n\nfragment RequestShippingQuote_user on User {\n  ...AddressSelector_user\n}\n\nfragment AddressSelector_user on User {\n  serviceId\n  firstValidShippingAddress {\n    serviceId\n    id\n  }\n  addressBook {\n    addressList {\n      serviceId\n      line2\n      displayName\n      formattedAddress\n      displayCountry\n      firstName\n      lastName\n      line1\n      sourceId\n      country\n      city\n      state\n      zipCode\n      phoneNumber\n      validation {\n        buyerShipping {\n          valid\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment RequestShippingQuote_viewer on Viewer {\n  ...AddressSelector_viewer\n}\n\nfragment AddressSelector_viewer on Viewer {\n  ...AddressForm_viewer\n}\n\nfragment AddressForm_viewer on Viewer {\n  geography {\n    countries {\n      name\n      abbreviation\n    }\n    usStates {\n      name\n      abbreviation\n    }\n  }\n  zipCodeLookUp: zipCode(zipCode: $zipCode, country: $country) @include(if: $canCheckZipCode) {\n    city\n    state\n    id\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./assets/js/contact/dealer/components/__generated__/MultiContactDealerModalRendererQuery.graphql.js